import { render, staticRenderFns } from "./banner-info.vue?vue&type=template&id=c018d61e&scoped=true"
import script from "./banner-info.vue?vue&type=script&lang=js"
export * from "./banner-info.vue?vue&type=script&lang=js"
import style0 from "./banner-info.vue?vue&type=style&index=0&id=c018d61e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c018d61e",
  null
  
)

export default component.exports